// import * as constants from 'constants';
import { ExceptionService } from '../services/exception.service';
import { ActivatedRoute, PRIMARY_OUTLET } from '@angular/router';
import { TogetherAppRoutes } from '../routes/app.routes';
import {
  ChangeDetectorRef, Component, ElementRef,
  EventEmitter, Input, OnInit, Output
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormArray, FormControl } from '@angular/forms';
import {
  TogetherAuctionDIPIncomeDetails,
  TogetherAuctionDIPApplicantDetail_Request,
} from './../models/api.models';
import { TogetherDIPStageContainer } from './../models/app.models';

// Services
import { NodeAPIEntityService } from './../services/node.entity.service';
import { DipStateService } from './../services/dip-state-service.service';
import { EntityStateService } from './../services/entity-state.service';

// Enums
import {
  TogetherAuctionDIPEntityOperation,
  TogetherAuctionDIPEntityState,
  TogetherAuctionDIPEntityType,
  TogetherAuctionDIPApplicantIterationType,
} from './../models/enums';
import * as _ from 'lodash-es';

@Component({
    selector: 'together-auction-dip-income-details',
    templateUrl: './dip.income_details.component.html',
    providers: [NodeAPIEntityService],
    standalone: false
})
export class TogetherAuctionDIPIncomeDetailsComponent implements OnInit {


  /**
   * The incomes coming from the income components.
   *
   * @type {FormArray}
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  tadIncomes: UntypedFormArray = new UntypedFormArray([]);

  /**
   * FormGroup for the income details.
   *
   * @type {FormGroup}
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  tadIncomeDetailsForm: UntypedFormGroup;

  /**
   * TODO: Replace with logic placed into the stage service.
   *
   * @type {TogetherDIPStageContainer}
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  @Input() stage: TogetherDIPStageContainer;

  /**
   * TODO: Replace with logic placed into the stage service.
   *
   * @type {string}
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  @Input() incoming_case_id: string;

  /**
   * TODO: Replace with logic placed into stage service.
   *
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  @Output() stage_changing = new EventEmitter();

  /**
   * The action text for when the applicant changes.
   *
   * @type {string}
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  actionText: string = 'Add another income';

  /**
   * The applicants, against which, incomes are stored.
   *
   * @type {Array<TogetherAuctionDIPApplicantDetail_Request>}
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  // tslint:disable-next-line:prefer-array-literal
  applicants: Array<TogetherAuctionDIPApplicantDetail_Request> = [];

  /**
   * The applicant iterator (TODO: Remove this shit.)
   *
   * @type {number}
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  // tslint:disable-next-line:variable-name
  current_applicant_iterator: number = 0;


  /**
   * The current iterator for the applicant.
   *
   * @type {number}
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  currentApplicantIterator: number = 0;

  /**
   * The current applicant. (TODO: Remove this shit)
   *
   * @type {TogetherAuctionDIPApplicantDetail_Request}
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  currentApplicant: TogetherAuctionDIPApplicantDetail_Request;

  /**
   * Is this the last applicant? (TODO: Remove this shit)
   *
   * @type {boolean}
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  // tslint:disable-next-line:variable-name
  is_last_applicant: boolean = false;

  /**
   * Incomes for this applicant.
   *
   * @type {Array<TogetherAuctionDIPIncomeDetails>}
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  // tslint:disable-next-line:prefer-array-literal
  applicantIncomes: Array<TogetherAuctionDIPIncomeDetails> = [
    new TogetherAuctionDIPIncomeDetails()
  ];

  /**
   * Sub-elements which are linked to this income.
   *
   * @type {Array<string>}
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  // tslint:disable-next-line:prefer-array-literal
  loadingElements: Array<string> = [];


  /**
   * The incomes.
   *
   * @type {Map<string,Array<TogetherAuctionDIPIncomeDetails>>}
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  // tslint:disable-next-line:prefer-array-literal
  incomes: Map<string, Array<TogetherAuctionDIPIncomeDetails>>
    = new Map<string, Array<TogetherAuctionDIPIncomeDetails>>();


  /**
   * Used for moving through the applicant sequence.
   *
   * @type {Map<string,[number,boolean]>}
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  applicantSequenceOrder: Map<number, [string, boolean]>
    = new Map<number, [string, boolean]>();


  /**
   * Fragment used to scroll to bottom of incomes.
   *
   * @type {*}
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  fragment: any;

  /**
   * Signals that when the loading is done, if it's adding an income, to do something.
   *
   * @type {boolean}
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  isAddingIncome: boolean = false;

  /**
   *
   *
   * @type {boolean}
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  isSubmitted: boolean = false;

  /**
   *
   *
   * @type {boolean}
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  hasBusinessApplicant: boolean = false;

  /**
   *
   *
   * @readonly
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  get applicantCurrentIncomes() {
    if (this.incomes.size === 0) {
      return [];
    }

    // Get the current applicant Id
    const currentApplicantId = this.currentApplicantId;
    return this.incomes.get(currentApplicantId);
  }

  /**
   * Gets all the elements that can issue status commands to the service.
   *
   * @readonly
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  get allEntities() {
    return this.loadingElements.concat(['IncomeDetails']);
  }

  /**
   * Shorthand function which checks entity state service to see if there are entities loading.
   *
   * @readonly
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  get isPageLoading() {
    return this.entityState.areEntitiesLoading(this.allEntities);
  }

  /**
   * Gets full name of current applicant.
   *
   * @readonly
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  get currentApplicantFullName() {
    return _.isNil(this.currentApplicant) ? '' : this.currentApplicant.FullName;
  }

  /**
   * Shortcut for both template and component to see if form is valid.
   *
   * @readonly
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  get isFormValid() {
    return this.tadIncomes.valid;
  }

  /**
   * Gets the current applicant that's selected.
   *
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  get currentSelectedApplicant() {
    let app = [];

    // Loop each sequence order.
    this.applicantSequenceOrder.forEach((val: [string, boolean], key: number) => {
      if (val[1] === true) {
        app = [key, val];
        return;
      }
    });

    // Return app
    return app;
  }

  /**
   * Rebuilds the form group.
   *
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  rebuildFormGroup() {
    this.tadIncomeDetailsForm = this.fb.group({
      incomes: this.tadIncomes,
    });
  }

  /**
   * Handles form in from income.
   * TODO: Replace with two-way binding and iterator.
   *
   * @param {any} form
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  handleFormFromChild(form) {

    // Get the iterator and the form.
    const iterator: number = form.iter;
    const inForm: UntypedFormGroup = form.form as UntypedFormGroup;

    // Remove that element from the array.
    this.tadIncomes.removeAt(iterator);
    this.tadIncomes.setControl(iterator, inForm);

    // Add the incomes array back into the form.
    this.tadIncomeDetailsForm.removeControl('incomes');
    this.tadIncomeDetailsForm.addControl('incomes', this.tadIncomes);

    // Refresh validity.
    this.tadIncomeDetailsForm.updateValueAndValidity();
    this.cdr.detectChanges();
  }


  /**
   * Resets the applicant incomes.
   *
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  initApplicantIncomes() {
    this.applicantIncomes = [
      new TogetherAuctionDIPIncomeDetails(),
    ];
  }

  /**
   * Reorders the income array.s
   *
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  reorderIncomeArray() {
    this.applicantIncomes = _.filter(this.applicantIncomes, income => !_.isNil(income));
  }


  /**
   * Handles what happens when loading is complete.
   *
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  handleLoadingComplete() {
    if (this.isAddingIncome) {
      this.addIncomeToUI();
      this.isAddingIncome = false;
    }
  }

  /**
   * Removes the income from the form array.
   *
   * @param {number} iterator
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  removeIncomeFromForm(iterator: number) {

    // Firstly, remove the item from the array of form stuff.
    // tslint:disable-next-line:prefer-const
    let formIncomes: UntypedFormArray = this.tadIncomeDetailsForm.get('incomes') as UntypedFormArray;

    // If there are no incomes, do nothing.
    if (_.isNil(formIncomes)) {
      return;
    }

    formIncomes.removeAt(iterator);

    // Filter and re-set.
    this.tadIncomeDetailsForm.setControl('incomes', formIncomes);
  }

  /**
   * Remove the income from the array.
   *
   * @param {string} id
   * @param {number} iterator
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  removeIncomeFromIncomeArray(id: string, iterator: number) {
    let incomes = this.incomes.get(id);
    delete incomes[iterator];
    incomes = _.filter(incomes, item => !_.isNil(item));
    this.applicantIncomes = incomes;
    this.incomes.set(id, incomes);
    if (this.applicantIncomes.length === 0) {
      this.commandAddIncome();
    }
  }

  /**
   * Removes an income from the applicant array.
   *
   * @param {object} payload
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  removeIncomeFromApplicant(payload: object) {
    const iterator: number = payload['iterator'];
    const id: string = payload['applicantId'];

    // Remove from the form array and rebuild.
    this.removeIncomeFromForm(iterator);

    // Now transform that into an array, re-ordered, without that in it.
    this.removeIncomeFromIncomeArray(id, iterator);
  }

  /**
   * Gets the income coming back from the income component.
   *
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  getReturningIncome(payload: object) {
    const iterator: number = payload['iterator'];
    const id: string = payload['applicantId'];
    const income: TogetherAuctionDIPIncomeDetails = payload['income'];

    // Now need to find what is the lowest iterator.
    const applicantIncome = this.incomes.get(id);

    // Prevent nil, our old best friend.
    if (_.isNil(applicantIncome)) {
      return;
    }

    // If it's the first income.
    const isFirstIncome = applicantIncome.length === 1;

    // Now we need the length of it.
    if (isFirstIncome && iterator === 0) {
      this.incomes.set(id, [income]);
    }
  }

  /**
   * Subscribes to changes relating to child elements from entity state service.
   *
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  subscribeToChildChanges() {

    // Subscribe to when child elements finish loading.
    this.entityState.subscribeWaitForLoadingComplete(this.loadingElements).subscribe(
      (success) => {
        this.handleLoadingComplete();
      },
      (error) => {
        this.handleLoadingComplete();
      },
    );


    this.entityState.subscribeToSingleCastCommand().subscribe(
      (success) => {
        const entity = success[0];
        const operation = success[1];
        const payload = success[2];

        if (operation === TogetherAuctionDIPEntityState.Deleted) {
          this.removeIncomeFromApplicant(payload);
        }
        if (operation === TogetherAuctionDIPEntityState.Saved) {
          this.getReturningIncome(payload);
        }
      },
    );

  }

  /**
   * Populates the loadingElements array with the names of all sub-elements.
   *
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  populateIncomeLoadingData() {
    // Populate loadingElements for all the child components.
    this.loadingElements = Array.from(
      // tslint:disable-next-line:prefer-array-literal
      new Array(this.applicantIncomes.length + 1),
      (val, index) => {
        return 'Applicant' + this.current_applicant_iterator + 'Income' + index;
      },
    );

    // Sets the entities as loading
    this.entityState.setEntitiesLoading(this.loadingElements);

    // Delay loading state being set as otherwise the load loses spinner.
    this.setParentState(TogetherAuctionDIPEntityState.OperationIdle);
  }

  /**
   * Populates applicantIncomes from income map.
   *
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  populateIncomes() {

    // Get the current applicant's Id.
    const applicantId = this.currentApplicant.Id;

    // Get the incomes from the map for that applicant.
    let incomes = this.incomes.get(applicantId);

    // If the incomes are empty, init with a default.
    if (_.isEmpty(incomes) === true) {
      incomes = [new TogetherAuctionDIPIncomeDetails()];

      // Set a default inside the map.
      this.incomes.set(applicantId, incomes);
    }

    // Set applicant incomes to the value.
    this.applicantIncomes = incomes;

    // Sets the loading elements so we can monitor them.
    this.populateIncomeLoadingData();
  }

  /**
   * Creates an income map of applicant -> incomes.
   *
   * @returns
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  defaultIncomeMap() {
    // If the incomes aren't empty, don't default the map.
    if (this.incomes.size > 0) {
      return;
    }

    // Get the list of applicants.
    const incomes = _.transform(this.applicants, (iter, n) => {

      // The first iterator is undefined
      if (!_.isNil(n)) {
        iter.push([n.Id, []]);
        return true;
      }
    }, []);

    // Set in the incomes map.
    // tslint:disable-next-line:prefer-array-literal
    this.incomes = new Map<string, Array<TogetherAuctionDIPIncomeDetails>>(incomes);

  }


  /**
   * Inserts incomes into income map.
   *
   * @param {Array<any>} incomes
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  insertIncomesInMap(incomes: Array<any>): void {
    _.each(incomes, (item) => {
      if (!_.isNil(item)) {
        // Get the id of the case applicant.
        const id = item.CaseApplicantId;

        // Get the current items in the array we already defaulted.
        // tslint:disable-next-line:prefer-const
        let items = this.incomes.get(id);

        // Now Push the item onto it.
        items.push(new TogetherAuctionDIPIncomeDetails(item));

        // Now reset in the map.
        this.incomes.set(id, items);
      }
    });
  }

  /**
   * Gets income data from the API.
   *
   * @param {any} caseId
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  getIncomesData(caseId) {
    this.setParentState(TogetherAuctionDIPEntityState.OperationPending);
    this.entity.getAllEntities(TogetherAuctionDIPEntityType.EmploymentDetails, caseId)
      .subscribe(
        (success) => {
          // Sets the income map for each applicant so we can shuffle through.
          this.defaultIncomeMap();

          // Map incomes to map
          this.insertIncomesInMap(success as Array<any>);

          // Sets the current incomes for an applicant based upon the current applicant.
          this.populateIncomes();

          // Populates the loading names for all the incomes generated here.
          this.populateIncomeLoadingData();

          // Set the current applicant
          this.initApplicantIterator();

          // Force all applicants to be collapsed when loading.
          this.forceIncomeCollapse(false);
        },
        (error) => {
          this.exception.haveReceivedError(error);
          this.setParentState(TogetherAuctionDIPEntityState.Error);
        },
      );
  }

  /**
   * Filter business applicants from the array.
   *
   * @param {Array<TogetherAuctionDIPApplicantDetail_Request>} applicants
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  // tslint:disable-next-line:prefer-array-literal
  orderAndFilterApplicants(applicants: Array<TogetherAuctionDIPApplicantDetail_Request>) {

    // Is this a business applicant.
    let isBusinessApplicant = false;

    // Order the applicants
    // tslint:disable-next-line:prefer-array-literal
    let apps: Array<TogetherAuctionDIPApplicantDetail_Request> =
      _.transform(
        applicants,
        (iter: Array<TogetherAuctionDIPApplicantDetail_Request>,
          n: TogetherAuctionDIPApplicantDetail_Request) => {

          // If a sneaky pete bug creeps in.
          if (!_.isNil(n)) {
            // Get the legalBodyRoleTypeChickenSandwichLoveThisReallyAwesomeName
            const legalType = _.toNumber(n.LegalBodyRoleTypeId);

            // If it's not type 2, add and sequence, otherwise
            if (legalType !== 2) {
              const pos = n.ApplicantSequence;
              iter[pos] = n;
              return true;
            } else {
              isBusinessApplicant = true;
            }
          }
        }, []);

    // If it's business applicant, we need to reorder the array.
    if (isBusinessApplicant) {
      const allApps = apps.slice(2);
      apps = _.concat(null, allApps);
    }

    // Set to the component for use in the movement map.
    this.hasBusinessApplicant = isBusinessApplicant;

    // Return the apps
    return apps;
  }


  /**
   * Iterates the current applicant either forwards, backwards or initialises
   * (i.e. After retrieve of applicants).
   *
   * @param {TogetherAuctionDIPApplicantIterationType} operation
   * @param {number} [iterator=null]
   * @returns
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  iterateCurrentApplicant(
    operation: TogetherAuctionDIPApplicantIterationType,
    iterator: number = null,
  ) {
    const busIterator = this.hasBusinessApplicant ? iterator - 1 : iterator;

    if (operation === TogetherAuctionDIPApplicantIterationType.Init) {
      this.currentApplicant = this.applicants[1];
      this.currentApplicantIterator = 1;
    } else if (operation === TogetherAuctionDIPApplicantIterationType.Forward &&
      !this.isLastIterator ||
      operation === TogetherAuctionDIPApplicantIterationType.Back && !this.isFirstIterator) {
      this.currentApplicant = this.applicants[busIterator];
      this.currentApplicantIterator = busIterator;
    } else {
      return;
    }
  }

  /**
   * Increments the current applicant.
   *
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  incrementCurrentApplicant() {

    // Get the sequence from the object.
    const currentApplicantIterator = this.currentApplicant.ApplicantSequence;

    // Business app causes it to be incremented by one and the array to be out.
    if (this.hasBusinessApplicant) {
      currentApplicantIterator - 1;
    }

    // Unless it's the last iterator, we don't mind.
    if (!this.isLastIterator) {
      this.iterateCurrentApplicant(
        TogetherAuctionDIPApplicantIterationType.Forward, currentApplicantIterator + 1);
    }
  }

  /**
   * Decrements the current applicant.
   *
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  decrementCurrentApplicant() {
    // Get the sequence from the object.
    const currentApplicantIterator = this.currentApplicant.ApplicantSequence;
    const decrementBy = this.hasBusinessApplicant ? 2 : 1;
    const iterator = currentApplicantIterator - decrementBy;

    // Unless it's the first iterator, move backwards.
    if (!this.isFirstIterator) {
      this.iterateCurrentApplicant(TogetherAuctionDIPApplicantIterationType.Back, iterator);
    }
  }

  /**
   * Gets applicant data from the API.
   *
   * @param {any} caseId
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  getApplicantData(caseId: string) {
    this.setParentState(TogetherAuctionDIPEntityState.OperationPending);
    // tslint:disable-next-line:no-this-assignment
    const self = this;
    this.entity.getAllEntities(TogetherAuctionDIPEntityType.ApplicantsPersonal, caseId)
      .subscribe(
        (success) => {

          // Create the applicants array.
          const applicants =
            (success as Array<any>).map(resp => new TogetherAuctionDIPApplicantDetail_Request(resp));

          // Returns the applicants array, ordered.
          this.applicants = this.orderAndFilterApplicants(applicants);

          // Set incomeDetails element in the entity state service as saved.
          this.setParentState(TogetherAuctionDIPEntityState.Saved);

          // Iterate the applicant to the first applicant.
          this.iterateCurrentApplicant(TogetherAuctionDIPApplicantIterationType.Init);

          // Default the map values.
          this.initIncomeMap();

          // Init map for moving back and forward.
          this.initMovementMap(); // Added for moving backwards and forwards.

          // We need the incomes *after*, to stop race condition issues.
          this.getIncomesData(this.incoming_case_id);

        },
        (error) => {
          this.exception.haveReceivedError(error);
          this.setParentState(TogetherAuctionDIPEntityState.Error);
        },
      );
  }

  /**
   * Checks to see. (TODO: Move to service. )
   *
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  init() {
    // Is the entity not new? If so, let's get the details.
    if (this.entity.isNew(this.incoming_case_id) === false) {
      this.getApplicantData(this.incoming_case_id);
    } else {
      // If we're not allowed to have a new reference, move.
      if (this.entity.allowNew(this.stage.current_stage.reference) === false) {
        this.stage_changing.emit('tad_stage_info');
      }
    }
  }

  /**
   * Sets the state of the income details component with the entity state service.
   *
   * @param {TogetherAuctionDIPEntityState} state
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  setParentState(state: TogetherAuctionDIPEntityState) {
    this.entityState.setEntityState('IncomeDetails', state);
  }

  /**
   * Deals with adding an income to the UI.
   *
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  addIncomeToUI() {

    const id = this.currentApplicant.Id;

    // Get the current applicant's incomes.
    // tslint:disable-next-line:prefer-const
    let currentIncomes = this.incomes.get(id);

    // Add an income to that array.
    currentIncomes.push(new TogetherAuctionDIPIncomeDetails());

    // Set the incomes.
    this.incomes.set(id, currentIncomes);
  }

  /**
   * Emits a save command to all sub entities.
   *
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  commandAddIncome() {

    // Forces incomes to collapse.
    this.forceIncomeCollapse(true);

    this.isAddingIncome = true;
    this.entityState.addStateCommand('*ANY*', TogetherAuctionDIPEntityOperation.Save);
    this.entityState.waitForElementsToFinishLoading(this.loadingElements).subscribe(
      () => { },
      () => { },
      () => {
        // Add an income to the UI.
        this.addIncome(this.currentApplicant.Id);

        // Move the viewport.
        this.moveViewToBelowIncomes();
      },
    );
  }


  /**
   * Handle backward move.
   *
   * @param {any} backward
   * @memberof TogetherAuctionDIPLoanDetailComponent
   */
  onBackwardClicked(backward) {
    if (this.isFirstIterator) {
      this.stage_changing.emit(this.stage.backward_stage.reference);
    } else {
      this.handleMoveBackOrSave();
    }
  }


  /**
   * Handles action (add income)
   *
   * @param {any} action
   * @memberof TogetherAuctionDIPLoanDetailComponent
   */
  onActionClicked(action) {
    if (this.isFormValid) {
      this.commandAddIncome();
    }
  }

  /**
   * Add an income.
   *
   * @param {string} applicantId
   * @param {TogetherAuctionDIPIncomeDetails} income
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  addIncome(
    applicantId: string,
    income: TogetherAuctionDIPIncomeDetails = new TogetherAuctionDIPIncomeDetails()) {

    if (this.tadIncomeDetailsForm.invalid || this.isPageLoading) {
      return;
    }

    // Get the item out of the map.
    // tslint:disable-next-line:prefer-const
    let incomes = this.incomes.get(applicantId);

    // add the income to the item.
    incomes.push(income);

    // Set in the map.
    this.incomes.set(applicantId, incomes);
  }

  /**
   * Initialises the income map with all the guids of the applicants.
   *
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  initIncomeMap() {
    const incomes = _.transform(
      // tslint:disable-next-line:prefer-array-literal
      this.applicants, (iter: Array<any>, n: TogetherAuctionDIPApplicantDetail_Request) => {

        if (_.isNil(n)) {
          return false;
        }

        const incomeId = n.Id;
        iter.push([incomeId, [new TogetherAuctionDIPIncomeDetails()]]);
        return true;
      }, []);
    // tslint:disable-next-line:prefer-array-literal
    this.incomes = new Map<string, Array<TogetherAuctionDIPIncomeDetails>>(incomes);
  }

  /**
   * Inits the map used to track movement backwards and forwards.
   *
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  initMovementMap() {
    // The applicants are transformed into just a map of sequence
    const applicants = _.transform(
      // tslint:disable-next-line:prefer-array-literal
      this.applicants, (iter: Array<any>, n: TogetherAuctionDIPApplicantDetail_Request) => {

        if (!_.isNil(n)) {
          // Get the sequence so we know where to insert it in the map.
          const sequence = n.ApplicantSequence;

          // Default as false, unless it's first, then we change to true.
          let loadingStatus = false;

          // Check if it has a business applicant.
          const isBusinessApplicant = this.hasBusinessApplicant;

          // Check if it's a business applicant, if it is, adjust the sequence.
          const adjustedSequence = isBusinessApplicant ? 2 : 1;

          // For the first iter, we set it by default as the current.
          if (sequence === adjustedSequence) {
            loadingStatus = true;
          }

          // Push in the default format for the map [ [number,[string,bool]] ]
          iter.push([sequence, [n.Id, loadingStatus]]);
          return true;
        }
      }, []);

    // Default the map to default the order.
    this.applicantSequenceOrder = new Map<number, [string, boolean]>(applicants);
  }

  /**
   * When moving between applicant incomes, switch which incomes are displayed.
   *
   * @param {string} applicantId
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  switchApplicantIncomes() {

    // Get the current applicant Id.
    const Id = this.currentApplicant.Id;

    // Get the incomes for that applicant.
    let incomes = this.incomes.get(Id);

    // If empty, default with an income in the UI.
    if (_.isEmpty(incomes)) {
      this.addIncomeToUI();
      incomes = this.incomes.get(Id);
    } else {
      incomes = _.filter(incomes, income => !income.isNew);
    }

    // Replace all the empties.
    this.incomes.set(Id, incomes);
  }

  /**
   * Moves to the next applicant.
   *
   * @param {object} currentApplicant
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  moveToNextApplicant() {

    // Get the applicant iterator.
    const applicantIterator = this.currentSelectedApplicant[0];

    // Check if the next iterator exists.
    const nextIterator = applicantIterator + 1;

    // Get the next applicant.
    // tslint:disable-next-line:prefer-const
    let nextApplicant = this.applicantSequenceOrder.get(nextIterator);

    // If it's not there, we don't need to do anything.
    if (_.isNil(nextApplicant)) {
      return;
    }

    // Only init this after the
    // tslint:disable-next-line:prefer-const
    let currentApplicant = this.applicantSequenceOrder.get(applicantIterator);

    // Reset so we can prepare to re-set in map.
    currentApplicant[1] = false;
    nextApplicant[1] = true;

    // Reset in the map.
    this.applicantSequenceOrder.set(applicantIterator, currentApplicant);
    this.applicantSequenceOrder.set(nextIterator, nextApplicant);
  }


  /**
   * Is this the first applicant? If so, move back to previous screen.
   *
   * @returns
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  isFirstApplicantMove() {
    const applicantIterator = this.currentSelectedApplicant[0];
    const nextIterator = applicantIterator - 1;
    return nextIterator < 1;
  }

  /**
   * Is this the last applicant? If so, move to next screen.
   *
   * @returns
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  isLastApplicantMove() {

    // Get the iterator.
    const applicantIterator = this.currentSelectedApplicant[0];

    // The next iterator.
    const nextIterator = applicantIterator + 1;

    // Get the next iterator.
    return nextIterator > this.highestIterator;
  }


  /**
   * Moves the iterator to the previous applicant.
   *
   * @returns
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  moveToPreviousApplicant() {

    // Get the iterator.
    const applicantIterator = this.currentSelectedApplicant[0];

    // Get the previous iterator.
    const prevIterator = applicantIterator - 1;

    // Get the previous applicant.
    // tslint:disable-next-line:prefer-const
    let previousApplicant = this.applicantSequenceOrder.get(prevIterator);

    if (_.isNil(previousApplicant)) {
      return;
    }

    // Get current applicant after the return to prevent allocating.
    const currentApplicant = this.applicantSequenceOrder.get(applicantIterator);

    // Reset the map.
    currentApplicant[1] = false;
    previousApplicant[1] = true;

    // Reset in the map.
    this.applicantSequenceOrder.set(applicantIterator, currentApplicant);
    this.applicantSequenceOrder.set(prevIterator, previousApplicant);
  }

  /**
   * Initialises the applicant iterator.
   *
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  initApplicantIterator() {
    // Get the applicant iterator so we have the guid.
    // tslint:disable-next-line:prefer-const
    let applicant = this.applicantSequenceOrder.get(1);

    // If applicant isnt there, something bad happened.
    if (_.isNil(applicant)) {
      return;
    }

    // Set as default.
    applicant[1] = true;

    // Applicant sequnce is set.
    this.applicantSequenceOrder.set(1, applicant);
  }

  /**
   * Handles moving backwards or forwards.
   *
   * @param {TogetherAuctionDIPApplicantIterationType} operation
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  doApplicantAction(operation: TogetherAuctionDIPApplicantIterationType) {
    if (operation === TogetherAuctionDIPApplicantIterationType.Forward) {

      // Now increment the applicant.
      this.incrementCurrentApplicant();

      // Is this the last applicant?
      const isLastApplicant = this.isLastApplicantMove();

      // If this is the last applicant.
      if (isLastApplicant) {
        this.stage_changing.emit(this.stage.current_stage.forward_reference);
      } else {
        // Firstly, set the iterator up so we know where we are.
        this.moveToNextApplicant();

        // Switch the incomes.
        this.switchApplicantIncomes();
      }

      // Force to collapse on next clicked.
      this.forceIncomeCollapse(false);
    } else if (operation === TogetherAuctionDIPApplicantIterationType.Back) {

      // Decrement the current applicant!
      this.decrementCurrentApplicant();

      // Is this the first applicant?
      const isFirstApplicant = this.isFirstApplicantMove();

      if (isFirstApplicant) {
        this.stage_changing.emit(this.stage.current_stage.backward_reference);
      } else {
        this.moveToPreviousApplicant();
        this.switchApplicantIncomes();
      }

      // Force to collapse on next clicked.
      this.forceIncomeCollapse(false);
    } else {
      return;
    }
  }

  /**
   * Gets the iterators from the map.
   *
   * @returns
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  getIterators() {

    // Default to 1 because, we don't want to point to 0, ever.
    const iterators = [];

    // Loop each
    const entries = this.applicantSequenceOrder.forEach(
      (val: [string, boolean], key: number) => {
        iterators.push(key);
      });
    return iterators;
  }

  /**
   * Gets the current applicant Id.
   *
   * @readonly
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  get currentApplicantId() {
    if (_.isNil(this.currentSelectedApplicant) || _.isEmpty(this.currentSelectedApplicant)) {
      return '';
    }

    const applicant = this.currentSelectedApplicant[1];
    return applicant[0];
  }

  /**
   * Gets the current applicant incomes.
   *
   * @readonly
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  get currentApplicantIncomes() {
    return this.incomes.get(this.currentApplicantId);
  }

  /**
   * Gets the highest iterator on the sequence order.
   *
   * @returns
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  get highestIterator() {
    const iterators = this.getIterators();
    return _.max(iterators);
  }

  /**
   * Gets first iterator.
   *
   * @readonly
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  get firstIterator() {
    const iterators = this.getIterators();
    return _.min(iterators);
  }

  /**
   * Gets the text for the button. If it's the first iterator, show back to applicant details.
   *
   * @readonly
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  get backwardText() {
    return this.isFirstIterator ? 'Applicant details' : 'Previous applicant incomes';
  }

  /**
   * Gets the text for the forward button.
   *
   * @readonly
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  get forwardText() {
    return this.isLastIterator ? 'Property details' : 'Next applicant\'s income';
  }

  /**
   * Gets if is first iterator.
   *
   * @readonly
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  get isFirstIterator() {

    // Get the first iterator.
    const firstIterator = this.firstIterator;

    // Get the current iterator.
    const currentIterator = this.currentSelectedApplicant;

    if (!_.isObject(currentIterator)) {
      return;
    }

    return currentIterator[0] === firstIterator;
  }

  /**
   * Getter if this is the last iterator.
   *
   * @readonly
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  get isLastIterator() {

    // Get the highest iterator.
    const highestIterator = this.highestIterator;

    // Get the item of the highest iterator.
    const currentIterator = this.currentSelectedApplicant;

    // Is the current iterator empty? If so, adios.subscribeWaitForLoadingComplete
    if (!_.isObject(currentIterator)) {
      return;
    }

    // Check if the current iterator is set
    return currentIterator[0] === highestIterator;
  }

  /**
   * Checks if there are untouched incomes on the page.
   *
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  checkHasOpenNewIncomes() {

    // Get the incomes from the form array.
    const incomes = this.tadIncomeDetailsForm.get('incomes').value;

    // Get the last income.
    const incomeItems = this.applicantCurrentIncomes;

    // Get the last item from the incomes
    const thisIncome = incomeItems[this.applicantCurrentIncomes.length - 1];

    // Check if the three items are empty
    return thisIncome.isNew;
  }


  /**
   * Forces child incomes to collapse the income details box.
   *
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  forceIncomeCollapse(isSaving: boolean = false) {

    // Nil prevention check.
    if (_.isNil(this.applicantCurrentIncomes) || _.isEmpty(this.applicantCurrentIncomes)) {
      return;
    }

    // Get the first income.
    const firstIncome = this.applicantCurrentIncomes[0];

    // Get the Id of the first income.
    const id: string = firstIncome.Id;
    const isNew: boolean = this.entity.isNew(id);

    // If it's new and not saving, dont collapse.
    if (isNew && !isSaving) {
      return;
    }

    // Otherwise we collapse all of it.
    this.entityState.issueNoReturnStateCommand(
      '*ANY*',
      TogetherAuctionDIPEntityOperation.ForceCollapse,
    );

  }

  /**
   * Handles the moving backward switching.
   * If it's first iterator, move back to prev page, otherwise swap back.
   *
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  handleMoveBackOrSave() {

    // Set state as loading.
    this.setParentState(TogetherAuctionDIPEntityState.OperationPending);

    // Forces the income to collapse.
    this.forceIncomeCollapse(true);

    // Issue the command, wait for stuff.
    this.entityState.issueStateCommand(
      this.loadingElements,
      '*ANY*',
      TogetherAuctionDIPEntityOperation.Save,
    ).subscribe(
      (success) => { },
      (error) => { },
      () => {
        this.setParentState(TogetherAuctionDIPEntityState.Saved);
        this.doApplicantAction(TogetherAuctionDIPApplicantIterationType.Back);
      },
    );
  }

  /**
   * Moves the view to below the incomes.
   *
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  moveViewToBelowIncomes() {
    try {
      if (this.fragment) {
        document.querySelector('#' + this.fragment).scrollIntoView();
      }
    } catch (e) { }
  }

  /**
   * Handles logic for moving forward and saving before doing so .
   *
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  moveForwardToggleApplicant(moveForward: boolean = false) {

    // Set the state as loading.
    this.setParentState(TogetherAuctionDIPEntityState.OperationPending);

    // Forces income to collapse.
    this.forceIncomeCollapse(true);

    // Issue the command, then wait for the respons to occur.
    this.entityState.issueStateCommand(
      this.loadingElements,
      '*ANY*',
      TogetherAuctionDIPEntityOperation.Save,
    ).subscribe(
      (success) => { },
      (error) => { },
      () => {

        // Set the entity state as saved.
        this.setParentState(TogetherAuctionDIPEntityState.Saved);

        // Now the thing has finished saving, we need to move the iterator forward.
        this.doApplicantAction(TogetherAuctionDIPApplicantIterationType.Forward);

        // Move the view to below incomes.
        this.moveViewToBelowIncomes();
      },
    );
  }

  /**
   * Force incomes to validate.
   *
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  forceIncomesToValidate() {
    this.entityState.issueStateCommand(
      this.loadingElements,
      '*ANY*',
      TogetherAuctionDIPEntityOperation.ForceValidate,
    ).subscribe(
      (success) => { },
      (error) => { },
      () => {
        return;
      },
    );
  }

  /**
   * Handles whether we should move next or save.
   *
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   **/
  handleMoveNextOrSave() {
    // Is the form valid?
    if (this.isFormValid) {
      // If it's the last iterator, we move forward.
      this.moveForwardToggleApplicant(this.isLastIterator);
    } else {
      this.forceIncomesToValidate();
    }
  }

  /**
   * Handler for when forward clicked.
   *
   * @param {any} forward
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  onForwardClicked(forward) {
    this.isSubmitted = true;
    this.handleMoveNextOrSave();
  }


  /**
   * Subscribe to fragment changes.
   *
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  subscribeToFragmentChanges() {
    this.route.fragment.subscribe((fragment) => {
      this.fragment = fragment;
    });
  }

  /**
*
*
* @memberof TogetherAuctionDIPApplicantDetailsComponent
*/
  ngAfterViewChecked() {
    if (this.isSubmitted) {
      const element = this.elementRef.nativeElement.querySelector('.is-invalid');
      if (!_.isNil(element)) {
        element.scrollIntoView();
        this.isSubmitted = false;
      }
    }
  }


  /**
   * Implements OnInit.
   *
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  ngOnInit() {
    this.init();
    this.subscribeToChildChanges();
    this.subscribeToFragmentChanges();
  }

  /**
   * Creates an instance of TogetherAuctionDIPIncomeDetailsComponent.
   * @param {NodeAPIService} api
   * @param {FormBuilder} fb
   * @param {NodeAPIEntityService} entity
   * @param {DipStateService} state
   * @param {EntityStateService} entityState
   * @memberof TogetherAuctionDIPIncomeDetailsComponent
   */
  constructor(
    private fb: UntypedFormBuilder,
    private entity: NodeAPIEntityService,
    private state: DipStateService,
    private elementRef: ElementRef,
    private entityState: EntityStateService,
    private route: ActivatedRoute,
    private exception: ExceptionService,
    private cdr: ChangeDetectorRef,
  ) {
    this.rebuildFormGroup();
  }

}
